export class ChangelogView {
	constructor(state, options = {}) {
		this.state = state;
		this.options = options;
		this.element = null;
		this._unsubscribe = null;

		// Configurable header colour — defaults to Product7 blue
		this._headerBg = `linear-gradient(180deg, #f0f4ff 0%, #ffffff 100%)`;
	}

	render() {
		this.element = document.createElement('div');
		this.element.className = 'messenger-view messenger-changelog-view';

		this._updateContent();

		this._unsubscribe = this.state.subscribe((type) => {
			if (type === 'changelogUpdate') {
				this._updateChangelogList();
			}
		});

		return this.element;
	}

	_updateContent() {
		this.element.innerHTML = `
			<div class="messenger-changelog-header">
				<div class="messenger-changelog-header-top">
					<h2>Latest Updates</h2>
					<button class="sdk-close-btn messenger-changelog-close-btn" aria-label="Close">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
							<path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
						</svg>
					</button>
				</div>
			</div>

			<div class="messenger-changelog-body">
				<div class="messenger-changelog-list"></div>
			</div>
		`;

		this._updateChangelogList();
		this._attachEvents();
	}

	_updateChangelogList() {
		const changelogContainer = this.element.querySelector(
			'.messenger-changelog-list'
		);
		const changelogItems = this.state.changelogItems;

		if (changelogItems.length === 0) {
			changelogContainer.innerHTML = this._renderEmptyState();
			return;
		}

		changelogContainer.innerHTML = changelogItems
			.map((item) => this._renderChangelogCard(item))
			.join('');

		this._attachChangelogEvents();
	}

	_renderChangelogCard(item) {
		const tagsHtml =
			item.tags && item.tags.length > 0
				? `<div class="messenger-changelog-tags">
					${item.tags.map((tag) => `<span class="sdk-badge sdk-badge-primary messenger-changelog-tag">${tag}</span>`).join('')}
				</div>`
				: '';

		const dateStr = this._formatDate(item.publishedAt || item.date);

		return `
			<div class="messenger-changelog-card" data-changelog-id="${item.id}">
				${
					item.coverImage
						? `
					<div class="messenger-changelog-cover">
						<img src="${item.coverImage}" alt="${item.title}" onerror="this.style.display='none';" />
					</div>
				`
						: ''
				}
				<div class="messenger-changelog-content">
					${tagsHtml}
					<h3 class="messenger-changelog-title">${item.title}</h3>
					${item.description ? `<p class="messenger-changelog-description">${this._truncateText(item.description, 100)}</p>` : ''}
					<div class="messenger-changelog-meta">
						<span class="messenger-changelog-date">${dateStr}</span>
					</div>
				</div>
			</div>
		`;
	}

	_renderEmptyState() {
		return `
			<div class="messenger-empty-state">
				<div class="messenger-empty-state-icon">
					<iconify-icon icon="ph:megaphone-duotone" width="48" height="48"></iconify-icon>
				</div>
				<h3>No changelog yet</h3>
				<p>Check back later for updates</p>
			</div>
		`;
	}

	_formatDate(dateString) {
		if (!dateString) return '';
		const date = new Date(dateString);
		return date.toLocaleDateString('en-US', {
			month: 'short',
			day: 'numeric',
			year: 'numeric',
		});
	}

	_truncateText(text, maxLength) {
		if (!text) return '';
		if (text.length <= maxLength) return text;
		return text.substring(0, maxLength).trim() + '...';
	}

	_attachEvents() {
		this.element
			.querySelector('.messenger-changelog-close-btn')
			.addEventListener('click', () => {
				this.state.setOpen(false);
			});

		this._attachChangelogEvents();
	}

	_attachChangelogEvents() {
		this.element
			.querySelectorAll('.messenger-changelog-card')
			.forEach((card) => {
				card.addEventListener('click', () => {
					const changelogId = card.dataset.changelogId;
					const changelogItem = this.state.changelogItems.find(
						(n) => n.id === changelogId
					);
					if (changelogItem?.url) {
						window.open(changelogItem.url, '_blank');
					} else if (this.options.onChangelogClick) {
						this.options.onChangelogClick(changelogItem);
					}
				});
			});
	}

	destroy() {
		if (this._unsubscribe) {
			this._unsubscribe();
		}
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}
	}
}
